import { render, staticRenderFns } from "./GroupMain.vue?vue&type=template&id=574c6534&scoped=true&"
import script from "./GroupMain.vue?vue&type=script&lang=js&"
export * from "./GroupMain.vue?vue&type=script&lang=js&"
import style0 from "./GroupMain.vue?vue&type=style&index=0&id=574c6534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c6534",
  null
  
)

export default component.exports